/* Published Judge.me records rendered once, with their original product attribution. */
(() => {
  const relative = new Intl.RelativeTimeFormat(document.documentElement.lang || 'en', {numeric:'always'});
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  function reviewerName(value) {
    const parts = String(value || '').trim().split(/\s+/u).filter(Boolean);
    if (parts.length < 2) return parts[0] || 'Customer';
    const initial = [...parts[parts.length - 1].replace(/\./g, '')][0];
    return initial ? `${parts[0]} ${initial.toLocaleUpperCase()}.` : parts[0];
  }
  function dateLabel(iso) {
    const stamp = Date.parse(iso);
    if (!Number.isFinite(stamp)) return '';
    const days = Math.max(0, Math.floor((Date.now() - stamp) / 86400000));
    if (!days) return 'Today';
    const unit = days >= 365 ? 'year' : days >= 30 ? 'month' : 'day';
    const n = unit === 'year' ? Math.floor(days / 365) : unit === 'month' ? Math.floor(days / 30) : days;
    return relative.format(-n, unit);
  }
  function initialise(feed) {
    if (feed.dataset.ready) return;
    const records = new Map();
    feed.querySelectorAll('[data-tac-review-source]').forEach(source => {
      let media = {};
      try { media = JSON.parse(source.querySelector('[data-tac-review-media]').textContent) || {}; } catch (_) { /* Original review still renders without supplementary media. */ }
      source.querySelectorAll('.jdgm-rev[data-review-id]').forEach(review => {
        if (!records.has(review.dataset.reviewId)) records.set(review.dataset.reviewId, {review, source, photos:media[review.dataset.reviewId] || [], date:review.querySelector('time')?.dateTime || ''});
      });
    });
    if (!records.size) { feed.hidden = true; return; }
    const list = feed.querySelector('[data-tac-review-list]');
    const reviews = [...records.values()].sort((a,b) => (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0));
    reviews.forEach(({review,source,photos,date}, index) => {
      const article = element('article','tac-review-feed__item');
      article.dataset.reviewId = review.dataset.reviewId;
      article.hidden = index >= 5;
      const identity = element('div','tac-review-feed__identity');
      identity.append(element('span','tac-review-feed__author',reviewerName(review.querySelector('.jdgm-rev__author')?.textContent)));
      identity.append(source.querySelector('[data-tac-review-product]').content.cloneNode(true));
      const content = element('div','tac-review-feed__content');
      const row = element('div','tac-review-feed__row');
      const score = Number(review.querySelector('[data-score]')?.dataset.score || 0);
      const stars = element('span','tac-review-feed__stars');
      stars.setAttribute('role','img'); stars.setAttribute('aria-label',`${score} out of 5 stars`);
      for (let i=1;i<=5;i++) { const star = element('span','','★'); if(i>score) star.dataset.empty=''; star.setAttribute('aria-hidden','true'); stars.append(star); }
      row.append(stars);
      if (date && dateLabel(date)) {
        const time = element('time','',dateLabel(date)); time.dateTime=date;
        time.title = new Date(date).toLocaleDateString(document.documentElement.lang || 'en',{year:'numeric',month:'long',day:'numeric',timeZone:'Asia/Kolkata'});
        row.append(time);
      }
      content.append(row);
      const title = review.querySelector('.jdgm-rev__title')?.textContent.trim();
      if(title) content.append(element('strong','tac-review-feed__title',title));
      const body = review.querySelector('.jdgm-rev__body')?.cloneNode(true);
      if(body) { body.className='tac-review-feed__body'; content.append(body); }
      const pictures = element('div','tac-review-feed__photos');
      const urls = new Set();
      const addPhoto = (url, alt) => {
        try { if(new URL(url,location.origin).protocol !== 'https:' || urls.has(url)) return; } catch (_) { return; }
        urls.add(url);
        const a = element('a'); a.href=url; a.target='_blank'; a.rel='noopener';
        a.setAttribute('aria-label',`Open customer photo from ${identity.textContent.trim()}`);
        const img = element('img'); img.src=url; img.alt=alt || 'Photo shared by this reviewer'; img.loading='lazy'; img.width=96; img.height=120; a.append(img); pictures.append(a);
      };
      review.querySelectorAll('.jdgm-rev__pics img').forEach(img => addPhoto(img.currentSrc || img.getAttribute('src') || img.dataset.src,img.alt));
      photos.forEach(photo => addPhoto(photo.url,'Original customer photo shared with this review'));
      if(pictures.children.length) content.append(pictures);
      article.append(identity,content); list.append(article);
    });
    const native = document.getElementById(feed.dataset.nativeSection);
    if(native) native.hidden=true;
    feed.dataset.ready='true';
    let shown = 5;
    const more = feed.querySelector('[data-tac-review-more]');
    more.hidden = reviews.length <= shown;
    more.addEventListener('click',() => {
      shown += 5;
      [...list.children].forEach((review,i) => { review.hidden=i>=shown; });
      more.hidden=shown>=reviews.length;
    });
    feed.querySelector('[data-tac-review-write]').addEventListener('click',() => {
      if(!native) return;
      native.hidden=false;
      const write = [...native.querySelectorAll('button,a')].find(button => button.textContent.trim().toLowerCase()==='write a review');
      if(write) { write.click(); native.hidden=true; }
      else native.scrollIntoView({block:'start',behavior:'instant'});
    });
  }
  function scrollToReview() {
    if(!['#tac-product-reviews','#tac-component-reviews','#judgeme_product_reviews'].includes(location.hash)) return;
    const feed=document.querySelector('[data-tac-review-feed][data-ready]');
    if(feed) requestAnimationFrame(() => feed.scrollIntoView({block:'start',behavior:'instant'}));
  }
  function start() { document.querySelectorAll('[data-tac-review-feed]').forEach(initialise); scrollToReview(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  window.addEventListener('load',scrollToReview,{once:true});
  window.addEventListener('hashchange',scrollToReview);
  document.addEventListener('shopify:section:load',start);
})();
